/**
 * True only for requests to the ARSON backend. Used to avoid leaking the session token
 * to third-party hosts (weather/elevation APIs, URLs from imported files...).
 * Requires a "/" right after the endpoint so look-alike hosts such as
 * "https://api.example.com/lora-webapp.evil.com" don't match.
 */
export function isApiUrl(url: string, apiEndpoint: string): boolean {
  if (!url || !apiEndpoint) return false;
  const base = apiEndpoint.endsWith("/") ? apiEndpoint : apiEndpoint + "/";
  return url.startsWith(base);
}

/** True if `hostname` is `domain` or one of its subdomains (case-insensitive). */
export function isHostOrSubdomain(hostname: string, domain: string): boolean {
  if (!hostname || !domain) return false;
  const host = hostname.toLowerCase();
  const target = domain.toLowerCase();
  return host === target || host.endsWith("." + target);
}
